function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { from, switchMap } from 'rxjs';
import { InjectableServices } from '../enums';
import { SuperSubject } from '../models';
import { colorPallete, getBlobBase64, getProperty, getRandomColor } from '../util';
import { WindowedObservable } from '../windowed-observable';
import { BaseConfigService } from './base-config.service';
var storageKey = 'usersAvatarImage';
export var AvatarService = /*#__PURE__*/ function(BaseConfigService) {
    "use strict";
    _inherits(AvatarService, BaseConfigService);
    function AvatarService(config) {
        _class_call_check(this, AvatarService);
        var _this;
        _this = _call_super(this, AvatarService, [
            config
        ]), _define_property(_this, "baseEndpoint", void 0), _define_property(_this, "isLoadingSubject", new SuperSubject(true)), _define_property(_this, "isLoading$", _this.isLoadingSubject.observable$), _define_property(_this, "availableAvatarsColors", _to_consumable_array(colorPallete)), _define_property(_this, "avatarsColorsSubject", new SuperSubject([])), _define_property(_this, "avatarsColors$", _this.avatarsColorsSubject.observable$), _define_property(_this, "resetAvailableAvatarsColors", function() {
            _this.isLoadingSubject.value = true;
            _this.availableAvatarsColors = _to_consumable_array(colorPallete);
        }), // any[], because it can be used with items collection
        _define_property(_this, "initAvatarColors", function(items, itemIdKey) {
            _this.resetAvailableAvatarsColors();
            var unique = Array.from(new Set(items.map(function(item) {
                return getProperty(item, itemIdKey.split('.'));
            })));
            _this.avatarsColorsSubject.value = unique.map(function(item) {
                return {
                    avatarId: item,
                    color: _this.pickAvatarColor()
                };
            });
            _this.isLoadingSubject.value = false;
        }), _define_property(_this, "initAndPersistAvatarColors", function(items, itemIdKey) {
            _this.isLoadingSubject.value = true;
            var existingColors = _this.avatarsColorsSubject.value;
            var unique = Array.from(new Set(items.map(function(item) {
                return getProperty(item, itemIdKey.split('.'));
            })));
            // Filter for item IDs that don't already have a color assigned
            var newItems = unique.filter(function(itemId) {
                return !existingColors.some(function(avatar) {
                    return avatar.avatarId === itemId;
                });
            });
            // Assign colors to new items
            var newColors = newItems.map(function(itemId) {
                return {
                    avatarId: itemId,
                    color: _this.pickAvatarColor()
                };
            });
            _this.avatarsColorsSubject.value = _to_consumable_array(existingColors).concat(_to_consumable_array(newColors));
            _this.isLoadingSubject.value = false;
        }), _define_property(_this, "pickAvatarColor", function() {
            if (_this.availableAvatarsColors.length < 1) {
                _this.resetAvailableAvatarsColors();
            }
            var color = getRandomColor(_this.availableAvatarsColors);
            _this.availableAvatarsColors = _this.availableAvatarsColors.filter(function(availableColor) {
                return availableColor !== color;
            });
            return color;
        });
        _this.baseEndpoint = _this.environment.AUTH_API_URL;
        return _this;
    }
    _create_class(AvatarService, [
        {
            key: "getAvatarColor",
            value: function getAvatarColor(itemId) {
                var getAvatarColor = this.avatarsColorsSubject.value.find(function(avatarColor) {
                    return avatarColor.avatarId === itemId;
                });
                return getAvatarColor ? getAvatarColor.color : '000000';
            }
        },
        {
            key: "getAvatarsCached",
            value: function getAvatarsCached() {
                var avatarsCached = sessionStorage.getItem(storageKey);
                if (avatarsCached) return JSON.parse(avatarsCached);
                sessionStorage.setItem(storageKey, JSON.stringify([]));
                var newAvatarsCached = sessionStorage.getItem(storageKey);
                return newAvatarsCached ? JSON.parse(newAvatarsCached) : null;
            }
        },
        {
            key: "getUserAvatarImage",
            value: function getUserAvatarImage() {
                var email = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
                var urlEndpoint;
                if (email) {
                    urlEndpoint = "".concat(this.baseEndpoint, "/User/avatar/email?").concat(new URLSearchParams({
                        email: email
                    }));
                } else {
                    throw new Error('Invalid params');
                }
                // get all avatars from session storage
                var avatarsCached = this.getAvatarsCached();
                // find avatar from array using fileGuid
                var avatarImageCached = this.getCachedAvatarImageByFileGuidOrEmail(avatarsCached, email);
                if (avatarImageCached) return avatarImageCached;
                return this.getAvatarImage(urlEndpoint, email);
            }
        },
        {
            key: "getUserAvatarImageAnonymous",
            value: function getUserAvatarImageAnonymous(profileId, email) {
                var urlEndpoint;
                if (profileId) {
                    urlEndpoint = "".concat(this.baseEndpoint, "/User/avatar/profile/").concat(profileId);
                } else {
                    throw new Error('Invalid params');
                }
                // get all avatars from session storage
                var avatarsCached = this.getAvatarsCached();
                // find avatar from array using fileGuid
                var avatarImageCached = this.getCachedAvatarImageByFileGuidOrEmail(avatarsCached, email);
                if (avatarImageCached) return avatarImageCached;
                return this.getAvatarImage(urlEndpoint, email);
            }
        },
        {
            key: "getCachedAvatarImageByFileGuidOrEmail",
            value: function getCachedAvatarImageByFileGuidOrEmail(avatarsCached, email) {
                var avatarUrl = avatarsCached === null || avatarsCached === void 0 ? void 0 : avatarsCached.find(function(avatar) {
                    if (email) {
                        return avatar.email === email;
                    }
                    return false;
                });
                if (avatarUrl === null || avatarUrl === void 0 ? void 0 : avatarUrl.url) {
                    return from([
                        avatarUrl.url
                    ]);
                }
                return null;
            }
        },
        {
            key: "getAvatarImage",
            value: function getAvatarImage(urlEndpoint, email) {
                var _this = this;
                return this.axios.get(urlEndpoint, {
                    responseType: 'arraybuffer'
                }).pipe(switchMap(/*#__PURE__*/ function() {
                    var _ref = _async_to_generator(function(param) {
                        var data, url, avatarsCached;
                        return _ts_generator(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    data = param.data;
                                    return [
                                        4,
                                        getBlobBase64(data)
                                    ];
                                case 1:
                                    url = _state.sent();
                                    if (typeof url !== 'string') throw new Error('Avatar not valid');
                                    avatarsCached = _this.getAvatarsCached();
                                    avatarsCached === null || avatarsCached === void 0 ? void 0 : avatarsCached.push({
                                        email: email,
                                        url: url
                                    });
                                    sessionStorage.setItem(storageKey, JSON.stringify(avatarsCached));
                                    return [
                                        2,
                                        url
                                    ];
                            }
                        });
                    });
                    return function(_) {
                        return _ref.apply(this, arguments);
                    };
                }()));
            }
        }
    ], [
        {
            key: "getOrCreate",
            value: function getOrCreate() {
                var key = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : InjectableServices.AvatarService;
                var observable = new WindowedObservable(key);
                var state = observable.getLastEvent();
                if (state) {
                    return state;
                }
                var instance = new AvatarService();
                observable.publish(instance);
                return instance;
            }
        }
    ]);
    return AvatarService;
}(BaseConfigService);
